
    import Component from "vue-class-component";
    import Vue from 'vue';
    import {Prop} from "vue-property-decorator";
    import {AddressModel} from "@/api-client";
    import {isNullOrWhiteSpace} from "@/extensions/string.helpers";
    import {cultureService} from "@/CultureService";

    const script = document.createElement('script')
    script.async = true;
    script.setAttribute('src', 'https://inaadress.maaamet.ee/inaadress/js/inaadress.min.js')
    document.head.appendChild(script);
    
    @Component
    export default class InAds extends Vue{
        @Prop({required: true})
        adsId!: string; 
        
        inAddress!: {hideResult():void};
        inAdsCouldNotBeLoaded = false;
        
        mounted(){
            if(!(window as any).InAadress){ // We don't want client to break when something goes wrong when loading inaadress.js. 
                this.inAdsCouldNotBeLoaded = true;
                return;
            }
            
            this.inAddress = new (window as any).InAadress({"container":this.adsId,"mode":"3","nocss":true,"appartment":1,"ihist":"1993","lang":cultureService.currentCulture2Letter});
            document.addEventListener("addressSelected", this.selectAddress);
        }
        
        
        selectAddress(e:any){
            const address = e.detail[0] as {ads_oid:string, adr_id:string, address:string, asum:string, maakond:string, sihtnumber: string, omavalitsus:string, liikluspind:string, aadress_nr:string, kort_nr:string, asustusyksus:string, nimi:string};
            this.inAddress.hideResult();
            this.$emit("address-selected", new AddressModel({
                adsOid: address.ads_oid || "",
                adrId: address.adr_id || "",
                countryOfResidence: "EE",
                province: address.maakond || "",
                municipality: address.omavalitsus || "",
                district: address.asustusyksus || "",
                street: (isNullOrWhiteSpace(address.liikluspind) ? address.nimi : address.liikluspind) || "",
                houseNumber: (isNullOrWhiteSpace(address.aadress_nr) ? address.nimi : address.aadress_nr) || "",
                flatNumber: address.kort_nr || "",
                postalCode: address.sihtnumber || ""
            }));
        }
        
        beforeDestroy(){
            document.removeEventListener("addressSelected", this.selectAddress);
        }
    }
